export default "__VITE_ASSET__f673d159__"